const ENV = import.meta.env.VITE_ENV;

const PROD_PRODUCTS = {
  audience: {
    id: 'prod_Mqjsr5uMuMHFhz',
    prices: {
      free: {
        id: 'price_1NsZtsEa9wlm13bUUjDrmYv5',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZtsEa9wlm13bUpHa0XH6o',
        price: 0,
      },
      silver: {
        id: 'price_1NsZttEa9wlm13bUL2vvnEzP',
        price: 0,
      },
      gold: {
        id: 'price_1NsZttEa9wlm13bUElzo4rC7',
        price: 0,
      },
    },
    group: 'audiences',
  },
  emailAddOn: {
    id: 'prod_MqjskUT8XAgLL3',
    prices: {
      free: {
        id: 'price_1NsZtuEa9wlm13bU0ohXga0e',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZtuEa9wlm13bUOEO0luUR',
        price: 0,
      },
      silver: {
        id: 'price_1NsZtuEa9wlm13bUeqN63MuO',
        price: 0,
      },
      gold: {
        id: 'price_1NsZtvEa9wlm13bUdssc9yyS',
        price: 0,
      },
    },
    group: 'audiences',
  },
  ipAddOn: {
    id: 'prod_Ofvl6MwQTj8pAY',
    prices: {
      free: {
        id: 'price_1NsZtvEa9wlm13bUwYpa6FGX',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZtvEa9wlm13bU3ST1nPe0',
        price: 0,
      },
      silver: {
        id: 'price_1NsZtvEa9wlm13bUpPOUiU4v',
        price: 0,
      },
      gold: {
        id: 'price_1NsZtwEa9wlm13bUECBv31CQ',
        price: 0,
      },
    },
    group: 'audiences',
  },
  phoneAddOn: {
    id: 'prod_MqjneWogEwWhgM',
    prices: {
      free: {
        id: 'price_1NsZtxEa9wlm13bUNN19IuHF',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZtxEa9wlm13bUMl5yGJCD',
        price: 0,
      },
      silver: {
        id: 'price_1NsZtxEa9wlm13bUOXPwv9HO',
        price: 0,
      },
      gold: {
        id: 'price_1NsZtxEa9wlm13bU0PIdcx1Q',
        price: 0,
      },
    },
    group: 'audiences',
  },
  identifierBundleAddOn: {
    id: 'prod_Ofvl4GAOACBUYM',
    prices: {
      free: {
        id: 'price_1NsZtyEa9wlm13bUZpTfPm4t',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZtyEa9wlm13bUMgiDAqbs',
        price: 0,
      },
      silver: {
        id: 'price_1NsZtyEa9wlm13bUXo34iIcs',
        price: 0,
      },
      gold: {
        id: 'price_1NsZtyEa9wlm13bUSjlYxWnM',
        price: 0,
      },
    },
    group: 'audiences',
  },
  digitalUseAddOn: {
    id: 'prod_OPotYHGwsoMMAs',
    prices: {
      free: {
        id: 'price_1NsZtzEa9wlm13bUiJbX1jxu',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZu0Ea9wlm13bUcpKnNV4a',
        price: 0,
      },
      silver: {
        id: 'price_1NsZu0Ea9wlm13bUI5indvgv',
        price: 0,
      },
      gold: {
        id: 'price_1NsZu0Ea9wlm13bUBVfg1Wiy',
        price: 0,
      },
    },
    group: 'audiences',
  },
  identifiers: {
    id: 'prod_OPRaPdBaH8Wxh0',
    prices: {
      free: {
        id: 'price_1NsZu1Ea9wlm13bU4Fbr5JRa',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZu1Ea9wlm13bUEvej7KnJ',
        price: 0,
      },
      silver: {
        id: 'price_1NsZu2Ea9wlm13bUq2MA0awo',
        price: 0,
      },
      gold: {
        id: 'price_1NsZu2Ea9wlm13bUdOGblOPu',
        price: 0,
      },
    },
    group: 'enhancements',
  },
  foundation: {
    id: 'prod_OPRatNAl2bsJj9',
    prices: {
      free: {
        id: 'price_1NsZu3Ea9wlm13bUWZW42d5B',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZu3Ea9wlm13bUbWomnAiI',
        price: 0,
      },
      silver: {
        id: 'price_1NsZu3Ea9wlm13bUUKWjr0F3',
        price: 0,
      },
      gold: {
        id: 'price_1NsZu4Ea9wlm13bUfjopGglG',
        price: 0,
      },
    },
    group: 'enhancements',
  },
  investing: {
    id: 'prod_OPRaGayJbkHbXm',
    prices: {
      free: {
        id: 'price_1NsZu5Ea9wlm13bU20Ao3cZY',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZu5Ea9wlm13bUA9NOP6rA',
        price: 0,
      },
      silver: {
        id: 'price_1NsZu5Ea9wlm13bUNpfoAZAY',
        price: 0,
      },
      gold: {
        id: 'price_1NsZu5Ea9wlm13bUi7ZKRfCX',
        price: 0,
      },
    },
    group: 'enhancements',
  },
  creditCards: {
    id: 'prod_OPRaa5iL4cKJZk',
    prices: {
      free: {
        id: 'price_1NsZu6Ea9wlm13bU2wGHtWSA',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZu7Ea9wlm13bUXk6DZhsX',
        price: 0,
      },
      silver: {
        id: 'price_1NsZu7Ea9wlm13bUtMLg0Ftm',
        price: 0,
      },
      gold: {
        id: 'price_1NsZu7Ea9wlm13bU83HBnnBI',
        price: 0,
      },
    },
    group: 'enhancements',
  },
  insurance: {
    id: 'prod_OPRaWAzH6vYSeh',
    prices: {
      free: {
        id: 'price_1NsZu8Ea9wlm13bUL92ulmkU',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZu8Ea9wlm13bUMxIiUHtJ',
        price: 0,
      },
      silver: {
        id: 'price_1NsZu9Ea9wlm13bUbI4S7Hee',
        price: 0,
      },
      gold: {
        id: 'price_1NsZu9Ea9wlm13bUusku4QHN',
        price: 0,
      },
    },
    group: 'enhancements',
  },
  customEnhancement: {
    id: 'prod_OY3ejosMx7UXba',
    prices: {
      free: {
        id: 'price_1NsZuAEa9wlm13bUCiWIfUbk',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZuAEa9wlm13bUjtDMb2Kn',
        price: 0,
      },
      silver: {
        id: 'price_1NsZuBEa9wlm13bUlB0NmTIL',
        price: 0,
      },
      gold: {
        id: 'price_1NsZuBEa9wlm13bUcaSEr0JU',
        price: 0,
      },
    },
    group: 'enhancements',
  },
  'audience-enhancement': {
    id: 'prod_OY3ejosMx7UXba',
    prices: {
      free: {
        id: 'price_1NsZuAEa9wlm13bUCiWIfUbk',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZuAEa9wlm13bUjtDMb2Kn',
        price: 0,
      },
      silver: {
        id: 'price_1NsZuBEa9wlm13bUlB0NmTIL',
        price: 0,
      },
      gold: {
        id: 'price_1NsZuBEa9wlm13bUcaSEr0JU',
        price: 0,
      },
    },
    group: 'enhancements',
  },
  measurementReport: {
    id: 'prod_OPotwXINIDhLZH',
    prices: {
      free: {
        id: 'price_1NsZuCEa9wlm13bU2QRZzW1W',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZuCEa9wlm13bUcq99Yp2w',
        price: 0,
      },
      silver: {
        id: 'price_1NsZuCEa9wlm13bUMG2JZpTM',
        price: 0,
      },
      gold: {
        id: 'price_1NsZuCEa9wlm13bUaaUq2NG8',
        price: 0,
      },
    },
    group: 'measurements',
  },
  'audience-profile': {
    id: 'prod_OPotwXINIDhLZH',
    prices: {
      free: {
        id: 'price_1NsZuCEa9wlm13bU2QRZzW1W',
        price: 0,
      },
      bronze: {
        id: 'price_1NsZuCEa9wlm13bUcq99Yp2w',
        price: 0,
      },
      silver: {
        id: 'price_1NsZuCEa9wlm13bUMG2JZpTM',
        price: 0,
      },
      gold: {
        id: 'price_1NsZuCEa9wlm13bUaaUq2NG8',
        price: 0,
      },
    },
    group: 'measurements',
  },
};

// TODO: Update when migrating to a live prod environment
const DEV_PRODUCTS = PROD_PRODUCTS;

const PRODUCTS = ENV === 'prod' ? PROD_PRODUCTS : DEV_PRODUCTS;

type Product = {
  id: string;
  priceId: string;
  price: number;
  quantity?: number;
};

export function getProduct(name: string, plan: string = 'free'): Product {
  // Temporary aliasing to support new default enhancement packages without Stripe product entries
  const aliases: Record<string, string> = {
    'SDOH and Health': 'foundation',
    analyticsBundle: 'foundation',
    businessCoreContacts: 'foundation',
    flaFriendly: 'foundation',
  };
  const key = (name in PRODUCTS) ? name : (aliases as any)[name] || name;
  const product = PRODUCTS[key];

  if (!product) {
    throw new Error(`No product named ${name}`);
  }

  return {
    id: product.id,
    priceId: product.prices[plan]?.id,
    price: product.prices[plan]?.price,
  };
}

export function getRate(name: string, plan: string = 'free'): number {
  const aliases: Record<string, string> = {
    'SDOH and Health': 'foundation',
    analyticsBundle: 'foundation',
    businessCoreContacts: 'foundation',
    flaFriendly: 'foundation',
  };
  const key = (name in PRODUCTS) ? name : (aliases as any)[name] || name;
  const product = PRODUCTS[key];

  if (!product) {
    throw new Error(`No product named ${name}`);
  }

  return product.prices[plan]?.price;
}
